<template>
  <v-card dark>
    <v-card-title v-if="props.title">
      {{ props.title }}
    </v-card-title>
    <v-card-text>
        <p class="subtitle-2 ma-0 lh-0 amber--text" v-if="title">{{ title }}</p>
        <p class="subtitle-1 ma-0 lh-0 " v-if="subtitle">{{ subtitle }}</p>
        <v-form @submit.prevent ref="form" v-model="valid">
          <v-row class="d-flex align-end space-between">
            <v-col cols="10">
              <v-text-field
                class="ma-0"
                label="Add an item"
                v-model.trim="item"
                :rules="titleRules"
                type="text"
                :color="color"
                required
                :hide-details="true"
              ></v-text-field>
            </v-col>
            <v-col cols="2" class="d-flex flex-row align-right">
              <v-btn
                :class="color"
                light
                color="amber"
                class="align-self-end align-right"
                @click="addNote"
                >Add</v-btn
              >
            </v-col>
          </v-row>
        </v-form>
   
      <div
        class="area area--h20 area--start"
        :class="{ 'area-full': fullHeight }"
      >
        <draggable class="inner" :list="items" group="notes">
          <v-chip
            class="ma-1"
            :color="color"
            light
            v-for="(tag, index) in items"
            :key="index"
          >
            <span class="pr-2 cursor--order">
              {{ tag }}
            </span>
            <v-icon small @click="removeItem(index)">mdi-close</v-icon>
          </v-chip>
        </draggable>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
// @ is an alias to /src
import draggable from "vuedraggable";
export default {
  name: "PropositionArea",
  props: {
    title: String,
    subtitle: String,
     color: {
      type: String,
      default: 'white'
    },
    value: {
      type: Array,
      defaults: [],
    },
     props: {
      type: Object,
      default: null,
    },
    fullHeight: Boolean,
    prefix: {
      type: String,
      default: "",
    },
  },
  components: {
    draggable,
  },
  data() {
    return {
      items: this.value,
      valid: true,
      item: "",
      titleRules: [(v) => !!v || "Title is required"],
    };
  },
  watch: {
    items: {
      deep: true,
      handler(val) {
        this.$emit("input", val);
      },
    },
    value(val) {
      this.items = val;
    },
  },
  methods: {
    addNote() {
      this.validate();
      if (this.valid) {
        this.items.push(this.item);
        this.item = "";
        this.resetValidation();
      }
    },
    removeItem(index) {
      this.items.splice(index, 1);
    },
    validate() {
      this.$refs.form.validate();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
  },
};
</script>

<style lang="scss">
.align-right {
  text-align: right;
}
</style>
